import React from 'react';

import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { useEmployerStaffsList } from 'src/hooks/employerStaff';
import { ResendInviteModal } from 'src/modals/invite';
import { prepareEmployerStaffFilter } from 'src/utils/employerStaff';

import { EmployerStaffTable } from '../EmployerStaffTable';

import { prepareSearchStaffsFilter } from './utils';

export interface EmployerStaffWrapperCVAdminProps {
  employerId?: string;
}

export const EmployerStaffWrapperCVandPEOStaff: React.FC<EmployerStaffWrapperCVAdminProps> = ({
  employerId,
}) => {
  const searchQueryVariables = useSearchQueryVariables(prepareSearchStaffsFilter);
  const { sortQueryVariable, filter, paginationQueryVariables, pagination } = useFilterStorage();

  const filterQueryVariables = React.useMemo(() => prepareEmployerStaffFilter(filter), [filter]);

  const { employerStaffsList, employerStaffsCount, loading, refetch } = useEmployerStaffsList(
    {
      filter: {
        employerId: { equals: employerId },
        ...filterQueryVariables,
        ...searchQueryVariables,
      },
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    },
    !employerId,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <React.Fragment>
      <EmployerStaffTable
        employerId={employerId}
        employerStaffList={employerStaffsList}
        employerStaffCount={employerStaffsCount}
        pagination={pagination}
        onRefresh={refetchData}
        loading={loading}
      />

      <ResendInviteModal />
    </React.Fragment>
  );
};
